import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useBrandStore } from './stores/brandStore'
import { observePaints } from './functions/telemetry'
// Self-hosted, so no third-party stylesheet sits on the critical path: Poppins everywhere, Barlow
// Condensed for VS Gaming's display lines. Latin subset, only the weights the CSS uses.
import '@fontsource/poppins/latin-300.css'
import '@fontsource/poppins/latin-400.css'
import '@fontsource/poppins/latin-500.css'
import '@fontsource/poppins/latin-600.css'
import '@fontsource/poppins/latin-700.css'
import '@fontsource/barlow-condensed/latin-600.css'
import '@fontsource/barlow-condensed/latin-700.css'
import './assets/css/main.css'

// Keep a copy of the nginx HE bootstrap for the ?debug panel; userAuthenticate.js deletes the original.
window.__WR_HE_SNAPSHOT__ = window.__WR_HE__ ? { ...window.__WR_HE__ } : null

const app = createApp(App)

app.use(createPinia())

// Brand must be known before any view renders: it drives theme, copy and product ids.
useBrandStore().resolveBrandFromHost()

app.use(router)

app.mount('#app')

// Real-user paint timings for the dashboard beacon (functions/telemetry.js).
observePaints()
